import { createSlice } from '@reduxjs/toolkit';

const routesSlice = createSlice({
  name: 'routes',
  initialState: {
    currentRoute: '',
    currentSubject: '',
  },
  reducers: {
    setRouteName(state, action) {
      state.currentRoute = action.payload;
    },
    setSubject(state, action) {
      state.currentSubject = action.payload;
    },
  },
});

export const { setRouteName, setSubject } = routesSlice.actions;

export default routesSlice.reducer;
